function refreshOverview() {
    window
        .fetch('/nettbutikk/kurv/cartoverview?storeId=' + window.br.storeId)
        .then(response => response.json().then(cart => {
            window.br.cart.totalQuantity = cart.totalQuantity;
        }));
}

function sendQuantity(url, sku, quantity) {
    return window.fetch(
            url,
            {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    storeId: window.br.storeId,
                    sku: sku,
                    quantity: quantity || 1
                })
            })
        .then(refreshOverview);
}

function prepLines(lines) {
    if (lines.length) {
        lines.forEach(line => {
            line.editing = false;
            line.newQuantity = line.quantity;
        });
    }
    return lines;
}

export default {

    addToCart(sku, quantity, total, product) {
        window.gtag('event',
            'add_to_cart',
            {
                currency: 'NOK',
                value: total,
                items: [{ item_id: sku, item_name: product.name, item_category: product.category, price: product.price, quantity: quantity }]
            });
        return sendQuantity('/nettbutikk/kurv/addtocart', sku, quantity);
    },
    updateCart(sku, quantity) {
        return sendQuantity('/nettbutikk/kurv/updatecart', sku, quantity);
    },
    fullCart() {
        return window.fetch('/nettbutikk/kurv/fullcart?storeId=' + window.br.storeId).then(result => result.json());
    },
    remove(sku) {
        window.gtag('event',
            'remove_from_cart',
            {
                currency: 'NOK',
                items: [{ item_id: sku }]
            });
        return window.fetch('/nettbutikk/kurv/remove?storeId=' + window.br.storeId + '&sku=' + sku).then(refreshOverview);
    },
    prepLines
};